import { createTheme } from "@mui/material/styles";

const getTheme = (mode = "light") =>
  createTheme({
    direction: "rtl",
    typography: {
      fontFamily: "Tajawal, Arial, sans-serif",
    },
    palette: {
      mode,
      ...(mode === "light"
        ? {
            primary: { main: "#1976d2" },
            background: { default: "#f5f5f5", paper: "#ffffff" },
            text: { primary: "#000000", secondary: "#555555" },
          }
        : {
            primary: { main: "#90caf9" },
            background: { default: "#121212", paper: "#1e1e1e" },
            text: { primary: "#ffffff", secondary: "#aaaaaa" },
          }),
    },

    components: {
      MuiTableCell: {
        styleOverrides: {
          root: ({ theme }) => ({
            color: theme.palette.text.primary, // auto adjusts for dark/light
            borderColor:
              theme.palette.mode === "light"
                ? theme.palette.grey[300]
                : theme.palette.grey[800],
          }),
          head: ({ theme }) => ({
            backgroundColor:
              theme.palette.mode === "light"
                ? theme.palette.grey[100]
                : theme.palette.grey[900],
            color: theme.palette.text.primary,
            fontWeight: "bold",
          }),
        },
      },
      MuiTableContainer: {
        styleOverrides: {
          root: ({ theme }) => ({
            backgroundColor: theme.palette.background.paper,
          }),
        },
      },
    },
  });

export default getTheme;
